export * from './lib/pipes/policy-icon.pipe';
